import {
  addNewAdminRoleAPI,
  addNewAdminUserAPI,
  getAdminRolesApi,
  getAdminUserByAdminIdApi,
  getAdminUsersApi,
  getOnboardingDataApi,
  getPermissionsApi,
  getPreferencesApi,
  getUserProfileInfoApi,
  getUsersApi,
  getUsersByIdsListApi,
  SearchUserApi,
  updateOnboardingDataApi,
} from 'redux/apis/Users';
import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';

// export const GET_USERS_REQUEST = "GET_USERS_REQUEST"
export const GET_USERS_SUCCESSFUL = 'GET_USERS_SUCCESSFUL';
// export const GET_USERS_FAILURE = "GET_USERS_FAILURE"

export function getUsers(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getUsersApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_USERS_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export function getAdminUsers(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAdminUsersApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_USERS_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_ADMIN_USER_SUCCESSFULL = 'GET_ADMIN_USER_SUCCESSFULL';
export function getAdminUserByAdminId(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAdminUserByAdminIdApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ADMIN_USER_SUCCESSFULL,
            id: id,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const SEARCH_USER_SUCCESSFUL = 'SEARCH_USER_SUCCESSFUL';
export function searchUser(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      SearchUserApi(data)
        .then(res => {
          dispatch({
            type: SEARCH_USER_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_ONBOARDING_SUCCESSFUL = 'GET_ONBOARDING_SUCCESSFUL';
export function getOnboardingData(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getOnboardingDataApi(data)
        .then(res => {
          dispatch({
            type: GET_ONBOARDING_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export function updateOnboardingData(data, userId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      updateOnboardingDataApi(data, userId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_PREFERENCES_SUCCESSFUL = 'GET_PREFERENCES_SUCCESSFUL';
export function getPreferences() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getPreferencesApi()
        .then(res => {
          dispatch({
            type: GET_PREFERENCES_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_ADMIN_ROLES_SUCCESSFUL = 'GET_ADMIN_ROLES_SUCCESSFUL';
export function getAdminRoles(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAdminRolesApi(data)
        .then(res => {
          dispatch({
            type: GET_ADMIN_ROLES_SUCCESSFUL,
            payload: res,
          });
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export function getPermissions() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getPermissionsApi()
        .then(res => {
          dispatch({
            type: GET_PERMISSIONS,
            payload: res.permissions,
          });
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export function addNewAdminRole(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      addNewAdminRoleAPI(data)
        .then(res => {
          dispatch(postSuccess(data && data.id ? 'Role Changed Successfully' : 'Role Added Successfully'));
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError(err.response && err.response.data.message));
          reject(err);
        });
    });
  };
}

export function addNewAdminUser(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      addNewAdminUserAPI(data)
        .then(res => {
          dispatch(postSuccess(res.message));
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError(err.response && err.response.data.message));
          reject(err);
        });
    });
  };
}

export function getUsersByIdsList(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getUsersByIdsListApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_USERS_SUCCESSFUL,
            payload: res.users_list,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}